<template>
  <div class="flex-auto page-padding forgetpassword-page">
    <!-- <el-button type="text" class="back"
               @click="reback">返回</el-button> -->
    <!-- <div class="identify-tar-title">重置密码</div> -->
    <div class="forgetpwd-main">
      <div class="forgetpwd-container">
        <el-form class="forgetpwd-form">
          <el-form-item class="form-item">
            <div class="forgetpwd-title">输入账号</div>
          </el-form-item>
          <el-form-item>
            <div class="forgetpwd-label">请输入要重置密码的账号</div>
          </el-form-item>
          <el-form-item class="form-item form-account">
            <span class="form-input-icon"><i class="iconfont icon-yonghuming"></i></span>
            <input type="text"
                   class="input-text form-input"
                   v-model="accountNumber"
                   placeholder="请输入账号" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       class="sign-button"
                       :loading="loading"
                       @click="confirm">
              下一步
            </el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from '@src/modules/forgetpassword/api/index.js'
export default {
  data () {
    return {
      loading: false,
      accountNumber: '',
      phone: ''
    }
  },
  methods: {
    reback () {
      this.$router.push({
        path: '/Login',
      })
    },
    confirm () {
      this.$fetch(api.queryPhoneByAccount, { accountNumber: this.accountNumber, })
        .then(res => {
          console.log(res,'-----res')
       
          if (res.msgCode == "0") {
            this.phone = res.returnObj.phone;
            this.$router.push({
              path: '/identifycode', query: { accountNumber: this.accountNumber, phone: this.phone }
            })
          } else {
            console.log(res, '====resa');
            this.$message({ type: 'error', message: res.msgContent })
          }
        })

    }
  }
}
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.forgetpassword-page {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  margin: 0;
  position: absolute;
  overflow: hidden;

  left: 0;
  top: 0;
  .back{
    margin-top: 10px;
    font-size: 14px;
  }
  .forgetpwd-main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
 
    .forgetpwd-container {
     margin-top: 80px;
    @include set_theme_color(background-color, blur-color);
      width: 380px;
      height:350px;
      padding: 20px;
      border-radius: 5px;
      position: relative;
      // background-color: rgba(0, 8, 75, 0.8);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .forgetpwd-form {
        width: 100%;
        top: 50px;
        .forgetpwd-label {
          font-size: 14px;
        }
        .form-item {
          position: relative;

          .forgetpwd-title {
            font-size: 24px;
            text-align: center;
            margin-bottom:30px;
            border-bottom: 2px solid;
             @include set_theme_color(border-color, top-menu-border-color);

          }
        }
        .form-account {
          .form-input {
            width: 40px;
            height: 40px;
            padding: 0 20px 0 40px;
            width: 100%;
            @include set_theme_color(background-color, top-menu-bg-color);
            -moz-box-shadow: none !important;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            border: 1px solid;
            @include set_theme_color(border-color, top-menu-border-color);
            @include set_theme_color(color, font-default-color);

            &:hover {
              @include set_theme_color(border-color, active-border-color);
            }

            &:focus {
              @include set_theme_color(border-color, active-border-color);
            }
          }
          .form-input-icon {
            position: absolute;
            top: 0px;
            left: 0px;
            width: 40px;
            height: 40px;
            text-align: center;

            i {
              font-size: 20px;
              line-height: 40px;
            }
          }
        }

        .input-text {
          padding-left: 25px;
          width: 100%;
          height: 40px;
        }
        .sign-button {
          width: 100%;
          margin-top:40px;
        }
      }
    }
  }
}
</style>